var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.emailSignupFormCustomInputTextV1 = {
    attach: function (context) {}
  };
})(jQuery);
